import React, { ReactElement } from "react";
import { FiCalendar } from "react-icons/fi";
import { RiUserLine } from "react-icons/ri";
import { GoCreditCard } from "react-icons/go";
import { FaVenusMars, FaTransgender } from "react-icons/fa";
import InputTextIcon from "../Inputs/InputTextIcon";
import InputTextDate from "../Inputs/InputTextDate";
import ButtonPair from '../Buttons/ButtonPair';
import ErrorLabel from '../Labels/ErrorLabel';
import ModalPopUp from '../ModalPopUp/ModalPopUp';
import HeaderTitle from "./HeaderTitle";
import { Dependant, TypeIdentification } from "../../store/medicalAppointment/types";
import { connect } from "react-redux";
import DropDownListIcon from "../DropDownList/DropDownListIcon";
import back from '../../images/ImagesSA/ButtonIcon/back.png';
import update from '../../images/ImagesSA/ButtonIcon/update.png';
import plusSmall from '../../images/ImagesSA/ButtonIcon/plusSmall.png';
import person from '../../images/ImagesSA/Dependent/person.png';
import information from '../../images/ImagesSA/Dependent/information.png';
import Styles from './DependentData.module.scss';
import * as Yup from 'yup';
import { validateNumber, validateLetter } from '../Inputs/FilterInputFunctions';
import { validateIdentificationEC } from "../../validations/documentvalidations";
import { validateDependentAge, validateRelationship, validateIdentification } from "../../validations/businessLogic.SA";
import { Formik, FormikProps } from 'formik';
import { postCreateDependant, putEditDependant } from "../../store/medicalAppointment/thunks";
import { ApiResponse } from '../../services/types';
import { typeIdentification, relationship, gender } from "../Parameters/Salud/ListParameter";

interface DependentDataProps {
    closePopUp: any,
    loadData: any,
    dependant: Dependant,
    putEditDependant?: any,
    postCreateDependant?: any,
    operationType: string,
    validatePartner:any,
    validateIdentification:any,
    errorMessage: ReactElement,

}

let validationSchema;
let title: string = "";

const DependentData: React.FC<DependentDataProps> = (props: DependentDataProps) => {

    title = props.operationType === "1" ? "Nuevo dependiente" : "Estás actualizando un dependiente";

    validationSchema = Yup.object().shape({
        firstName: Yup.string()
            .required('Se requiere rellenar este campo!'),
        lastName: Yup.string()
            .required('Se requiere rellenar este campo!'),
        birthdate: Yup.date()
            .required("Se requiere rellenar este campo!").nullable()
            .test('validar tipo parentesco con edad', '',
                function (value: string) {
                    return validateDependentAge(value, this)
                }),
        identification: Yup.string()
            .required('Se requiere rellenar este campo!')
            .when('typeIdentification', (typeIdentification: string, schema: any) => {
                if (typeIdentification === TypeIdentification.IdentificationCard)
                    return schema
                        .min(10, 'El dato ingresado es muy corto!')
                        .max(10, 'El dato ingresado es muy largo!')
                        .matches(/^[0-9]+$/gm, 'Solo se admiten  números!')
                        .required('Se requiere rellenar este campo!');
                if (typeIdentification === TypeIdentification.ForeignId)
                    return schema
                        .min(10, 'El dato ingresado es muy corto!')
                        .max(10, 'El dato ingresado es muy largo!')
                        .matches(/^[0-9]+$/gm, 'Solo se admiten  números!')
                        .required('Se requiere rellenar este campo!');
                if (typeIdentification === TypeIdentification.Passport)
                    return schema
                        .min(5, 'El dato ingresado es muy corto!')
                        .max(13, 'El dato ingresado es muy largo!')
                        .matches(/^[0-9A-Z-ÑÁÉÍÓÚ]+$/gm, 'Solo se admiten números y letras en mayúsculas!')
                        .required('Se requiere rellenar este campo!');
                return schema;
            })
            .test('validar identificación con tipo de identificacion', 'Cédula no válida',
                function (value: string) {
                    return validateIdentificationEC(value, this.parent.typeIdentification)
                })
            .test('validar identificación repetida', 'Existe ya un dependiente con esta identificación',
                function (value: string) {
                    return validateIdentification(props.validateIdentification(value), props.operationType)
                }),
        typeIdentification: Yup.string()
         .required('Se requiere rellenar este campo!'),
        gender: Yup.string()
            .required('Se requiere rellenar este campo!'),
        relationship: Yup.string()
            .required('Se requiere rellenar este campo!')
            .test('validar conyuge', 'Existe ya un dependiente con parentesco cónyuge',
                function (value: string) {
                    return validateRelationship(value,  props.validatePartner(this.parent.identification))
                })
    });

    const mask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];

    const changeBirthdate = (formikProps: FormikProps<Dependant>, date: Date) => {
        formikProps.setFieldValue("birthdate", date);
    }
    const handleSubmit = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, formikProps: FormikProps<Dependant>) => {
        let hasBeenTouched = formikProps.touched.firstName
            || formikProps.touched.lastName
            || formikProps.touched.birthdate
            || formikProps.touched.identification
            || formikProps.touched.gender
            || formikProps.touched.typeIdentification
            || formikProps.touched.relationship;

        if (hasBeenTouched === undefined) {
            formikProps.setFieldTouched("firstName");
            formikProps.setFieldTouched("lastName");
            formikProps.setFieldTouched("birthdate");
            formikProps.setFieldTouched("identification");
            formikProps.setFieldTouched("gender");
            formikProps.setFieldTouched("typeIdentification");
            formikProps.setFieldTouched("relationship");
            return;
        }

        let formIsValid = formikProps.errors.firstName
            || formikProps.errors.lastName
            || formikProps.errors.birthdate
            || formikProps.errors.identification
            || formikProps.errors.gender
            || formikProps.errors.typeIdentification
            || formikProps.errors.relationship
        if (formIsValid !== undefined) {
            return;
        }

        let response: ApiResponse = props.operationType === "1" ?
            await props.postCreateDependant(formikProps.values) :
            await props.putEditDependant(formikProps.values)

        if (response.StatusCode.toString() === "200") {
            props.loadData();
            props.closePopUp('dependent');
        }
    }

    return (
        <ModalPopUp classNameStyle="col-lg-8 col-md-8 col-sm-8 col-xs-8">
            <div className={Styles.scroll}>
                <div className="card-body mb-3">
                    <div className={Styles.marginRow}>
                        <HeaderTitle
                            title={title}
                            image={<img src={person}
                            className="img-fluid"
                            alt={title} />}
                        />
                    </div>
                    <div className={Styles.marginRow + " row"}>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left">
                            <h6 className={Styles.color} >Ingresa los datos del dependiente por favor</h6>
                        </div>
                    </div>
                    <div className={Styles.marginRow +  " row"}>
                        <div className=" col-lg-auto col-md-auto col-sm-auto col-xs-12 pt-2">
                            <img src={information} className="img-fluid" alt="Imagen Información"/>
                        </div>
                        <div className=" col-lg-10 col-md-10 col-sm-10 col-xs-12 pl-4 text-justify">
                            <sub>
                                Recuerda que la información que nos des debe ser verídica,
                                cuidamos muy bien tus datos y no compartimos tu información con nadie
                            </sub>
                        </div>
                    </div>
                        <Formik
                            initialValues={props.dependant}
                            validationSchema={ validationSchema  }
                            enableReinitialize = {true}
                            onSubmit={(values, { setSubmitting }) => {
                                setSubmitting(false);
                            }}
                            >
                        {(formikProps) => (
                            <form onSubmit={formikProps.handleSubmit}>
                                <div className="row mt-5">
                                    <div className="col-lg-5 col-md-12 col-sm-12 text-left">
                                        <span className="font-weight-bold">Información personal</span>
                                    </div>
                                    <div className="col-lg-6 col-md-12 col-sm-12">
                                        <DropDownListIcon
                                            id="relationship"
                                            name="relationship"
                                            styleClass="form-control"
                                            value={formikProps.values.relationship}
                                            onChange={formikProps.handleChange}
                                            data={relationship}
                                            className=""
                                            onBlur={formikProps.handleBlur}
                                            icon={<i><FaVenusMars /></i>}
                                            tabIndex={1}
                                        />
                                    {formikProps.touched.relationship && formikProps.errors.relationship && <ErrorLabel errorMessage={formikProps.errors.relationship} />}
                                        <InputTextIcon
                                            id="firstName"
                                            name="firstName"
                                            type="text"
                                            placeholder="Nombres"
                                            onChange={formikProps.handleChange}
                                            onBlur={formikProps.handleBlur}
                                            value={formikProps.values.firstName}
                                            onKeyDown={validateLetter}
                                            styleClass="form-control"
                                            icon={<i><RiUserLine /></i>}
                                            tabIndex={2}
                                        />
                                        {formikProps.touched.firstName && formikProps.errors.firstName && <ErrorLabel errorMessage={formikProps.errors.firstName} />}
                                        <InputTextIcon
                                            id="lastName"
                                            name="lastName"
                                            type="text"
                                            placeholder="Apellidos"
                                            onChange={formikProps.handleChange}
                                            onBlur={formikProps.handleBlur}
                                            value={formikProps.values.lastName}
                                            onKeyDown={validateLetter}
                                            styleClass="form-control"
                                            icon={<i><RiUserLine /></i>}
                                            tabIndex={3}
                                        />
                                        {formikProps.touched.lastName && formikProps.errors.lastName && <ErrorLabel errorMessage={formikProps.errors.lastName} />}
                                        <InputTextDate styleClass=" form-control"
                                            id="birthdate"
                                            name="birthdate"
                                            onChange={(date:Date)=>{changeBirthdate(formikProps,date)}}
                                            value={formikProps.values.birthdate}
                                            onBlur={formikProps.handleBlur}
                                            dateFormat="yyyy-MM-dd" icon={<i><FiCalendar /></i>}
                                            mask={mask}
                                            position="bottom"
                                            tabIndex={4}
                                            placeholderText="Fecha de nacimiento"/>
                                    { formikProps.errors.birthdate && <ErrorLabel errorMessage={formikProps.errors.birthdate} />}
                                        <DropDownListIcon
                                            id="typeIdentification"
                                            name="typeIdentification"
                                            styleClass="form-control"
                                            value={formikProps.values.typeIdentification}
                                            onBlur={formikProps.handleBlur}
                                            onChange={formikProps.handleChange}
                                            data={typeIdentification}
                                            className=""
                                            icon={<i><GoCreditCard /></i>}
                                            tabIndex={5}
                                            disabled={props.operationType === "2" ? true : false}
                                            />
                                        {formikProps.touched.typeIdentification && formikProps.errors.typeIdentification && <ErrorLabel errorMessage={formikProps.errors.typeIdentification} />}
                                        <InputTextIcon
                                            id="identification"
                                            name="identification"
                                            type="text"
                                            placeholder="Número de identificación"
                                            onChange={formikProps.handleChange}
                                            onBlur={formikProps.handleBlur}
                                            value={formikProps.values.identification}
                                            styleClass="form-control"
                                            icon={<i><GoCreditCard /></i>}
                                            tabIndex={6}
                                            disabled={props.operationType === "2" ? true : false}
                                        />
                                        {formikProps.touched.identification && formikProps.errors.identification && <ErrorLabel errorMessage={formikProps.errors.identification} />}                               
                                        <DropDownListIcon
                                            id="gender"
                                            name="gender"
                                            styleClass="form-control"
                                            value={formikProps.values.gender}
                                            onChange={formikProps.handleChange}
                                            data={gender}
                                            className=""
                                            onBlur={formikProps.handleBlur}
                                            icon={<i><FaTransgender /></i>}
                                            tabIndex={7}
                                        />
                                        {formikProps.touched.gender && formikProps.errors.gender && <ErrorLabel errorMessage={formikProps.errors.gender} />}
                                    </div>
                                </div>
                                <div className="mt-3">
                                    <ButtonPair
                                        idNext="btnNext"
                                        idPrevious="btnPrevious"
                                        onClickNext={(ev:React.MouseEvent<HTMLButtonElement, MouseEvent>)=>handleSubmit(ev, formikProps)}
                                        onClickBack={() => props.closePopUp('dependent')}
                                        textoButtonBack="Cancelar"
                                        textoButtonNext={props.operationType==="1" ? "Agregar": "Actualizar"}
                                        styleClass="mb-3"
                                        iconPrevious={<img src={back} alt="cancelar"/>}
                                        iconNext={props.operationType === "1" ?
                                            <img src={plusSmall} alt="agregar" /> :
                                            <img src={update} alt="actualizar" /> }
                                        minWidth="9rem"
                                        maxWidth="9rem"
                                    />
                                    {props.errorMessage}
                                </div>
                            </form>
                        )}
                    </Formik>
                </div>
            </div>
        </ModalPopUp>
    );
};

export default connect(null , { postCreateDependant, putEditDependant })(DependentData);